import { Chip } from "@mui/material";
import { useEffect } from "react";
import Typography from "@mui/material/Typography";

const UpcomingInterview = ({
  name,
  desg,
  profile,
  price,
  slot,
  status,
  id,
  payment,
  logo,
  update,
}) => {
  useEffect(() => {
    const ribbon = document.querySelectorAll(".ribbon");
    ribbon.forEach((item) => {
      if (item.classList.contains("active")) {
        item.parentElement.style.paddingRight = "20px";
      } else {
        item.parentElement.style.paddingRight = "0px";
      }
    });
  });

  if (payment === false) {
    return;
  }
  //   const timeDuration=(slot)=>{
  //     let text = slot
  // const myArray = text.split(" ");
  // const arr1=myArray[0].split(":")
  // const arr2=myArray[3].split(":")
  // const h1=parseInt(arr1[0]);
  // const h2=parseInt(arr2[0]);
  // const m1=parseInt(arr1[1]);
  // const m2=parseInt(arr2[1]);
  // return (60*(h2-h1)+(m2-m1))
  //   }
  return (
    <>
      <div className="relative w-full overflow-hidden bg-white box-shadow-request-card grid grid-cols-4 rounded-lg my-4 p-2">
        {/* Updated */}
        <div className="absolute h-full w-full unshow" id="updated">
          <div className="flex justify-center items-center h-full bg-gray-500/50">
            <div className="px-4 py-2 bg-green-500 rounded-md">
              <Typography variant="h4" component="h4" sx={{ color: "white" }}>
                Updated
              </Typography>
            </div>
          </div>
        </div>

        {/* Canceled */}
        <div className="absolute h-full w-full unshow" id="canceled">
          <div className="flex justify-center items-center h-full bg-gray-500/50">
            <div className="absolute text-2xl top-2 right-2 text-red-600 cursor-pointer hover:text-red-800">
              <i className="fa-solid fa-circle-xmark"></i>
            </div>
            <div className="px-4 py-2 bg-red-600 rounded-md">
              <Typography variant="h4" component="h4" sx={{ color: "white" }}>
                Canceled
              </Typography>
            </div>
          </div>
        </div>
        <div className="absolute bottom-1 right-2 text-right">
          <p className="text-xs text-gray-400">Sent 45 Min ago</p>
          <p className="text-xs text-gray-400">Accepted 15 Min ago</p>
        </div>
        <div className="border-r border-gray-400 my-auto col-span-1">
          <img
            src={require("../../../images/photo.png")}
            className="h-32 rounded-full border-2 border-black p-1 block mx-auto"
            alt="Profile"
          />
          <button className="view-profile-card-btn w-4/5 mt-2 mx-auto">
            View Profile
          </button>
        </div>
        <div className="px-3 col-span-3">
          <div className="flex py-1 justify-between w-full">
            <div className="w-12 h-12 logo-shadow mx-1 rounded-lg">
              <img src={require("../../../images/amazon.png")} alt="google" />
            </div>
            <div className="text-center">
              <h4 className="text-2xl font-medium leading-4">{name}</h4>
              <p>{desg}</p>
            </div>
            <div className="flex gap-2">
              <div className="flex justify-center border rounded-md p-2 w-10 h-10 text-blue-500 text-2xl hover:text-blue-600 cursor-pointer">
                <i className="fa-solid fa-bookmark"></i>
              </div>
              <div className="flex justify-center border rounded-md p-2 w-10 h-10 text-green-500 text-2xl hover:text-green-600 cursor-pointer">
                <i className="fa-solid fa-share"></i>
              </div>
            </div>
          </div>
          <div
            className="flex justify-between text-center my-1 gap-x-1 mx-2"
            style={{ alignItems: "flex-start" }}
          >
            <div>
              <p className="text-base text-gray-400">Profile</p>
              <Chip
                label={profile}
                color="info"
                sx={{ fontWeight: "medium" }}
              />
            </div>
            <div>
              <p className="text-base text-gray-400">Price</p>
              <p className="text-lg">INR 299</p>
            </div>
            <div>
              <p className="text-base text-gray-400">Session Duration</p>
              <p className="text-lg">30 Min</p>
            </div>
            <div>
              <p className="text-base text-gray-400">Interview Slot</p>
              <p className="text-lg">[{slot}]</p>
              <p className="text-lg">20 June, 2022</p>
            </div>
          </div>
          <div className="relative flex justify-center">
            <div className="meeting-id">Mock Interview ID: {id}</div>
            <button type="button" className="cust-btn join-meeting-btn">
              Join Meeting
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default UpcomingInterview;
